import { render, staticRenderFns } from "./ExpensesReport.vue?vue&type=template&id=c96ad1e8&scoped=true"
import script from "./ExpensesReport.vue?vue&type=script&lang=js"
export * from "./ExpensesReport.vue?vue&type=script&lang=js"
import style0 from "./ExpensesReport.vue?vue&type=style&index=0&id=c96ad1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96ad1e8",
  null
  
)

export default component.exports